/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Plugin controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetPluginByIdResponse, UpdatePluginRequest, GetPluginsResponse, CreatePluginRequest, CreatePluginResponse, GetPluginSelectResponse } from "../models";

@Injectable({ providedIn: "root" })
export class PluginService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getPluginById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetPluginByIdResponse>;
    getPluginById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetPluginByIdResponse>>;
    getPluginById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetPluginByIdResponse>>;
    getPluginById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Plugin/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updatePlugin(id: number, updatePluginRequest: UpdatePluginRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updatePlugin(id: number, updatePluginRequest: UpdatePluginRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updatePlugin(id: number, updatePluginRequest: UpdatePluginRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updatePlugin(id: number, updatePluginRequest: UpdatePluginRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Plugin/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updatePluginRequest, requestOptions);
    }

    deletePlugin(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deletePlugin(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deletePlugin(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deletePlugin(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Plugin/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    getPlugins(searchTerm?: string | null, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetPluginsResponse>;
    getPlugins(searchTerm?: string | null, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetPluginsResponse>>;
    getPlugins(searchTerm?: string | null, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetPluginsResponse>>;
    getPlugins(searchTerm?: string | null, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Plugin`;

        let params = new HttpParams();
        if (searchTerm != null) {
            params = HttpParamsBuilder.addToHttpParams(params, searchTerm, 'searchTerm');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createPlugin(createPluginRequest: CreatePluginRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreatePluginResponse>;
    createPlugin(createPluginRequest: CreatePluginRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreatePluginResponse>>;
    createPlugin(createPluginRequest: CreatePluginRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreatePluginResponse>>;
    createPlugin(createPluginRequest: CreatePluginRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Plugin`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createPluginRequest, requestOptions);
    }

    getPluginSelect(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetPluginSelectResponse>;
    getPluginSelect(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetPluginSelectResponse>>;
    getPluginSelect(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetPluginSelectResponse>>;
    getPluginSelect(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Plugin/Select`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }
}
